<template>
    <div class="breadcrumb">
        <p class="btn">
            <span>首页</span>
            >
            <span>{{(checkedTagType=='1'?'待接诊':
                    checkedTagType=='2'?'已接诊':
                    checkedTagType=='3'?'已结诊':
                    checkedTagType=='4'?'未结诊':''
                    )}}</span>
            >
            <span>{{(
                    checkedTagKey=='1'?'预约信息':
                    checkedTagKey=='2'?'病历':
                    checkedTagKey=='3'?'处方':
                    checkedTagKey=='4'?'检查':
                    checkedTagKey=='5'?'检验':''
                    )}}</span>
        </p>
        <p>
            <span v-show="NoCopyright">技术支持：北京天桃科技有限公司</span>
            <span>版本号：1.0.1</span>
        </p>
    </div>
</template>

<script>
import config from '@/config'
import { mapGetters } from 'vuex'
export default {
  props: {

  },
  data () {
    return {
      TagType: '待接诊',
      TagKey: '预约信息',
      NoCopyright: config.NoCopyright
    }
  },
  computed: {
    ...mapGetters({
      checkedTagKey: 'prvateConsultation/checkedTagKey',
      checkedTagType: 'prvateConsultation/checkedTagType'
    })
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
    .breadcrumb{
        position: absolute;
        bottom:0;
        z-index: 0;
        width:100%;
        margin-left: -7px;
        padding:0 20px;
        height: 20px;
        line-height: 20px;
        background: linear-gradient(to right, #eeeff2 0%, #eaf6fd 1%, #eaf6fd 100%);
        font-size:9px;
        font-family:MicrosoftYaHei;
        font-weight:400;
        color:rgba(51,51,51,1);
        display: flex;
        justify-content:space-between;
        color:#333;
        .btn{
            span{
                // cursor: pointer;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/private_consultation_page/fun_right/breadcrumb/index.vue